import React, { PropTypes } from 'react';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import PureComponent from 'components/PureComponent';
import { Link } from 'react-router';
import Button from 'components/Button';
import Drawer from 'components/Drawer';
import Footer from 'components/Footer';
import Socials from 'components/Socials';
import cookie from 'react-cookies';

import fetch from 'node-fetch';

class CityMenu extends React.Component {
  constructor() {
    super();
    this.state = {};

    this.handleCityAccept = this.handleCityAccept.bind(this);
  }

  static contextTypes = {
    deviceType: PropTypes.string
  };

  componentDidMount() {
    fetch('/files/cities.json')
      .then(r => r.json())
      .then(data => {
        this.setState({ cities: data.rows });
      })
      .catch(err => {
        console.log('Error: ' + err.message);
      });
  }

  handleCityAccept(city, link) {
    cookie.save('city', city);
    cookie.save('link', link);

    this.props.onClose();
  }

  render() {
    require('./CityMenu.styl');
    const { deviceType } = this.context;
    const drawerProps = {
      position: 'right',
      size: deviceType === 'mobile' ? '100%' : '50%',
      isOpen: this.props.isOpen,
      onClose: this.props.onClose,
      isBlue: true
    };

    const elem = this;

    if (this.state && this.state.cities) {
      const citiesRows = this.state.cities;
      return (
        <Drawer
          style={{
            backgroundColor: '#21c8ff',
            zIndex: 15
          }}
          {...drawerProps}
        >
          <div className="CityMenu">
            {citiesRows.map(function(row) {
              return (
                <div className="CityMenuRow">
                  {row.blocks.map(function(cityBlock) {
                    return (
                      <div className="CityBlock">
                        <div className="CityLetter">
                          <span>{cityBlock.letter}</span>
                        </div>
                        <div className="CityList">
                          {cityBlock.cities.map(function(city) {
                            return (
                              <a
                                data-link={city.link}
                                href={'javascript:void(0)'}
                                onClick={() =>
                                  elem.handleCityAccept(city.title, city.link)
                                }
                                className="CityItem"
                              >
                                {city.title == 'Москва'
                                  ? 'Москва ★'
                                  : city.title}
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </Drawer>
      );
    }

    return <span></span>;
  }
}

export default CityMenu;



// WEBPACK FOOTER //
// ./src/components/CityMenu/CityMenu.js